import toNumber from 'lodash-es/toNumber';
import React from 'react';
import { InputError, Maybe } from '../definition';

export function updateRefValue(
  ref: React.RefObject<HTMLInputElement>,
  value: Maybe<string | number>
) {
  if (ref && ref.current) {
    if (value?.toString() !== ref.current.value) {
      ref.current.value = value ? value.toString() : '';
    }
  }
}

export function getRangeInputError(
  value1?: string,
  value2?: string,
  acceptNegative?: boolean
) {
  const minimum = value1?.length ? toNumber(value1) : undefined;
  const maximum = value2?.length ? toNumber(value2) : undefined;

  if (!acceptNegative && !!minimum && minimum < 0)
    return InputError.NEGATIVE_NUMBER;
  if (!acceptNegative && !!maximum && maximum < 0)
    return InputError.NEGATIVE_NUMBER;

  if (!minimum || typeof maximum === 'undefined') return false;

  if (minimum > maximum) return InputError.INVALID_COMBINATION;
  return false;
}
